// Import Dependencies
import { Suspense } from 'react';

// ----------------------------------------------------------------------

const Loadable = (Component, Fallback) => {
  const WrappedComponent = (props) => (
    <Suspense fallback={Fallback && <Fallback />}>
      <Component {...props} />
    </Suspense>
  );
  WrappedComponent.displayName = `Loadable(${Component.displayName || Component.name || 'Component'})`;
  return WrappedComponent;
};

export { Loadable };
